import React, { FC } from 'react'

import * as S from './Avatar.styles'
import { AvatarProps } from './Avatar.types'

const Avatar: FC<AvatarProps> = ({
  initials,
  src,
  noBorder,
  bgColor,
  widthValue,
  heightValue,
  fontSizeValue,
  initialsColor,
  dashedBorder = false,
  badge,
  badgeOnTop = false,
  viewAsBorder,
}) => (
  <S.AvatarRoot
    src={src}
    noBorder={noBorder}
    bgColor={bgColor}
    fontSizeValue={fontSizeValue}
    widthValue={widthValue}
    heightValue={heightValue}
    dashedBorder={dashedBorder}
    viewAsBorder={viewAsBorder}
  >
    {badge && <S.Badge top={badgeOnTop}>{badge}</S.Badge>}
    {initials ? <S.Initials initialsColor={initialsColor}>{initials}</S.Initials> : null}
  </S.AvatarRoot>
)

export { Avatar }
